/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Overview_Finals_ReadyInputs */



/**
* | output |
* | --- |
* | "Finals ready!" |
*
* @param {Overview_Finals_ReadyInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const overview_finals_ready = /** @type {((inputs?: Overview_Finals_ReadyInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Overview_Finals_ReadyInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Finale prête !")
	if (locale === "es") return /** @type {LocalizedString} */ ("¡Finales listos!")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Finais prontas!")
	if (locale === "it") return /** @type {LocalizedString} */ ("Finali pronte!")
	return /** @type {LocalizedString} */ ("Finals ready!")
});